export default [
  {
    path: '/bus/setting',
    name: 'BusSetting',
    component: () => import('./Setting.vue'),
    meta: {title: '客车参数&模型'}
  },
]
